export function getIPv4SubnetValue(index: number): number {
    return 32 - index;
}
